<div class="spinner-wrapper" *ngIf="(isLoading$ | async) === true">
  <p-progressSpinner></p-progressSpinner>
</div>
